import { render, staticRenderFns } from "./AppDepartmentInfoBlock.vue?vue&type=template&id=8559c9c6&scoped=true"
import script from "./AppDepartmentInfoBlock.vue?vue&type=script&lang=js"
export * from "./AppDepartmentInfoBlock.vue?vue&type=script&lang=js"
import style0 from "./AppDepartmentInfoBlock.vue?vue&type=style&index=0&id=8559c9c6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8559c9c6",
  null
  
)

export default component.exports